import { TargetingTab } from './types';

export const TARGETING_TAB_PARAM = 'targeting-tab';
export const DEFAULT_TARGETING_TAB: TargetingTab = 'audiences';
export const TARGETING_TABS: TargetingTab[] = ['audiences', 'segments'];
